import * as S from './styles';
import { TOP_PROGRESS_BARRA_ID, TOP_PROGRESS_TRILHO_ID } from '@/shared/topProgress';

/**
 * Fita de 3px no topo da página.
 *
 * Fica sempre montada e invisível: quem a acende, move e apaga é o `topProgress`, mexendo direto
 * no DOM. Assim nenhuma atualização de progresso passa pelo React.
 */
const TopProgressBar = () => (
  <S.Trilho id={TOP_PROGRESS_TRILHO_ID} aria-hidden="true">
    <S.Barra id={TOP_PROGRESS_BARRA_ID} />
  </S.Trilho>
);

export default TopProgressBar;
